import { IExchangeData } from '@src/types/exchange'
import { IToken } from '@src/types/token'

/**
 * Check if a token is a stable asset
 * @param token The token to check
 * @returns boolean indicating if the token is a stable asset
 */
export const isStableAsset = (token?: IToken): boolean => {
    if (!token) return false

    // Check if the token has the isStableCoin property set
    if (token.isStableCoin === true) return true

    // Fallback check for common stable coins if the property isn't set
    const stableSymbols = ['USDC', 'USDT', 'DAI', 'BUSD', 'TUSD', 'USDP', 'FRAX', 'LUSD', 'GUSD', 'USDD']
    return stableSymbols.includes(token.symbol.toUpperCase())
}

/**
 * Check if the source amount in an exchange is from a stable asset
 * @param exchangeData The exchange data containing the token information
 * @returns boolean indicating if the source is a stable asset
 */
export const isSourceStableAsset = (exchangeData?: IExchangeData): boolean => {
    if (!exchangeData) return false
    return isStableAsset(exchangeData.token)
}
